var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSheild(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 30,
    viewBox: "0 0 26 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9974 1.66699C9.1974 1.66699 6.73473 4.36033 3.8214 5.34033C2.6374 5.74033 2.04406 5.93899 1.8054 6.22033C1.5654 6.50033 1.49473 6.91233 1.35473 7.73366C-0.147937 16.5283 3.13606 24.659 10.9667 27.8243C11.8081 28.1643 12.2294 28.3337 13.0014 28.3337C13.7734 28.3337 14.1961 28.1643 15.0374 27.8243C22.8681 24.659 26.1481 16.5283 24.6454 7.73366C24.5041 6.91233 24.4347 6.50166 24.1947 6.22033C23.9547 5.93899 23.3627 5.74033 22.1787 5.34033C19.2641 4.36033 16.7974 1.66699 12.9974 1.66699Z",
    stroke: "#68858C",
    strokeWidth: 1.48837,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.776 15.2236C14.1827 16.6303 16.036 18.0596 16.036 18.0596L18.576 15.5196C18.576 15.5196 17.1467 13.6663 15.74 12.2596C14.3334 10.853 12.48 9.42364 12.48 9.42364L9.94003 11.9636C9.94003 11.9636 11.3694 13.817 12.776 15.2236ZM12.776 15.2236L8.33203 19.6676M18.9987 15.0956L15.612 18.4823M12.9054 9.00098L9.5187 12.3876",
    stroke: "#68858C",
    strokeWidth: 1.48837,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSheild);
export default __webpack_public_path__ + "static/media/sheild.fb5deea77f90b3c638b131b367a6131e.svg";
export { ForwardRef as ReactComponent };